export const GUILD_EVENT_GAME_KEYS = ["where-winds-meet"] as const
export type GuildEventGameKey = (typeof GUILD_EVENT_GAME_KEYS)[number]

export const GUILD_EVENTS_SCHEDULE_CONFIG = {
  timezone: "Europe/Berlin",
  eventCreationJobTime: "06:00",
} as const
export type GuildEventScheduleTimezone =
  typeof GUILD_EVENTS_SCHEDULE_CONFIG.timezone
export const GUILD_EVENT_KINDS = ["raid", "attendance"] as const
export type GuildEventKind = (typeof GUILD_EVENT_KINDS)[number]

export const GUILD_EVENT_RSVP_STATES = [
  "attending",
  "tentative",
  "not_attending",
] as const
export type GuildEventRsvpState = (typeof GUILD_EVENT_RSVP_STATES)[number]

export const GUILD_EVENT_STATUSES = [
  "scheduled",
  "closed",
  "cancelled",
  "started",
  "announcement_missing",
  "archived",
] as const
export type GuildEventStatus = (typeof GUILD_EVENT_STATUSES)[number]

export const GUILD_EVENT_SYNC_STATUSES = ["healthy", "degraded"] as const
export type GuildEventSyncStatus = (typeof GUILD_EVENT_SYNC_STATUSES)[number]

export const WWM_EVENT_ROLE_CATALOG = {
  tank: "Tank",
  dps: "DPS",
  healer: "Healer",
} as const

export const WWM_EVENT_ROLE_MAX = Object.keys(WWM_EVENT_ROLE_CATALOG).length

export type WwmEventRoleKey = keyof typeof WWM_EVENT_ROLE_CATALOG

export const GUILD_EVENT_SCHEDULE_WEEKDAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const
export type GuildEventScheduleWeekday =
  (typeof GUILD_EVENT_SCHEDULE_WEEKDAYS)[number]
